// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"8176df9a","407":"b4a96cc1","460":"58b53117","487":"712e688d","581":"109cb3c4","869":"dd08ca44"}[chunkId] + ".chunk.js";
};